function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.3125 0.75C5.95264 0.75 5.58472 0.876221 5.32422 1.13672C5.06372 1.39722 4.9375 1.76514 4.9375 2.125V2.8125H0.8125V4.1875H1.5V15.1875C1.5 16.3181 2.43188 17.25 3.5625 17.25H11.8125C12.9431 17.25 13.875 16.3181 13.875 15.1875V4.1875H14.5625V2.8125H10.4375V2.125C10.4375 1.76514 10.3113 1.39722 10.0508 1.13672C9.79028 0.876221 9.42236 0.75 9.0625 0.75H6.3125ZM6.3125 2.125H9.0625V2.8125H6.3125V2.125ZM2.875 4.1875H12.5V15.1875C12.5 15.5688 12.1938 15.875 11.8125 15.875H3.5625C3.18115 15.875 2.875 15.5688 2.875 15.1875V4.1875ZM4.25 6.25V13.8125H5.625V6.25H4.25ZM7 6.25V13.8125H8.375V6.25H7ZM9.75 6.25V13.8125H11.125V6.25H9.75Z",
  fill: "#C40606"
});

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.e10c5831.svg";
export { ForwardRef as ReactComponent };